<script>
import BOForm from '../../baseComponents/boForm'
import { themes, usableDates, regexpDates } from '../../variables'

export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Nom', value: 'name', type: 'text', required: true },
				{ label: 'Clef', value: 'key', type: 'text', required: true },
				{
					label: 'Bots',
					value: 'bots',
					type: 'sub-array',
					items: [
						{
							label: 'Bot',
							value: '_id',
							type: 'select',
							values: this.$store.getters.bots,
							itemText: (subBot) => subBot.name,
							itemValue: (subBot) => subBot._id,
							required: true,
						},
						{ label: 'Label', value: 'label', type: 'text', required: true },
					],
				},
			],
		}
	},

	watch: {
		model() {
			if (!!this.model && !!this.model._id) {
				this.$set(this.items[1], 'disabled', true)

				this.items.splice(2, 0, {
					label: "Lien d'inscription",
					value: 'link',
					type: 'text',
					required: false,
					disabled: true,
				})
			}
		},
	},
	methods: {
		async post() {
			const { name, bots, key } = this.model
			await this.axios.post('bot-groups', { name, bots, key })
		},
		async put() {
			const { name, bots } = this.model
			await this.axios.put('bot-groups/' + this.model._id, { name, bots })
		},
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/botGroups/botGroups.form.vue